import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import { StoreState } from '@/interfaces'
import AccountStore from '@/stores/AccountStore'
import ActivityStore from '@/stores/ActivityStore'
import CircuitStore from '@/stores/CircuitStore'
import EquipmentStore from '@/stores/EquipmentStore'
import ExerciseStore from '@/stores/ExerciseStore'
import RoutineStore from '@/stores/RoutineStore'

Vue.use(Vuex)

const store: StoreOptions<StoreState> = {
  state: {
    initializing: false,
    version: '1.0.0'
  },
  modules: {
    account: AccountStore,
    activities: ActivityStore,
    circuits: CircuitStore,
    equipment: EquipmentStore,
    exercises: ExerciseStore,
    routines: RoutineStore
  },
  actions: {
    async initialize ({ commit, dispatch }) {
      commit('setInitializingState', true)

      await Promise.all([
        dispatch('activities/initialize'),
        dispatch('circuits/initialize'),
        dispatch('equipment/initialize'),
        dispatch('exercises/initialize'),
        dispatch('routines/initialize')
      ])

      await dispatch('account/initialize')

      commit('setInitializingState', false)
    }
  },
  mutations: {
    setInitializingState (state, payload: boolean) {
      state.initializing = payload || false
    }
  }
}

export default new Vuex.Store<StoreState>(store)
